import 'css-chunksrc/client/pages/projectPage/timeSheetPage/navigation/styles.scss';export default {
  "navigation": "_navigation_1754z_1"
};